/**
 * NUDIENT: Synk från sidkontext, paket A0, spec 4.6 och M-019.
 *
 * En sida som hör till exakt en modell sätter den modellen som vald, med källa
 * `page`. Vilken modell sidan hör till avgör Liquid i
 * `snippets/nudient-model-data.liquid`, som skriver ut den i `#nudient-model-page`.
 *
 * Tar också bort etiketten som head-scriptet satt, om det sparade valet inte
 * längre finns bland modellposterna. Det sparade värdet raderas inte, M-019.
 *
 * Körs igen när sidan visas ur webbläsarens bakåtcache, eftersom valet kan ha
 * ändrats i en annan flik under tiden.
 *
 * Värden som inte kommer från butiken eller en token:
 * - `nudient-model-page`: id på sidans modell.
 * - `page`: källan, spec 4.10.
 */

import { ready, hasData, findModel, getStoredModel, setModel } from '@nudient/model-store';

const PAGE_ID = 'nudient-model-page';

/** @returns {{ handle: string, name: string } | null} */
function readPageModel() {
  const element = document.getElementById(PAGE_ID);
  if (!element) return null;
  try {
    return JSON.parse(element.textContent || 'null');
  } catch {
    return null;
  }
}

function clearUnknownChoice() {
  if (!hasData()) return;
  const stored = getStoredModel();
  if (!stored || findModel(stored)) return;
  const dataset = document.documentElement.dataset;
  delete dataset.model;
  delete dataset.modelName;
}

async function sync() {
  await ready;
  clearUnknownChoice();
  const page = readPageModel();
  if (page?.handle) setModel(page.handle, page.name, 'page');
}

sync();

window.addEventListener('pageshow', (event) => {
  if (event.persisted) sync();
});
